export default __webpack_public_path__ + "static/media/logo-kingfreight.2d5f893e.jpg";